import { TIME_PATTERNS } from '../inputPatterns/time/formatLabel';
import { TIME_FORMATS, TimeFormatType } from '../inputPatterns/time/formats';
import { LOCALES, LocaleType } from './localeConstants';

const { HH_MM_A, HHMM_A, HHA, HH_MM, HHMM, HH_MM_SS_A, HH_MM_SS, HH_MM_SS_SSS_A, HH_MM_SS_SSS } = TIME_PATTERNS;
export const SUPPORTED_TIME_FORMATS_BY_LOCALE: Record<LocaleType, TimeFormatType[]> = {
  [LOCALES.EN_US]: [
    TIME_FORMATS[HH_MM_A], // "03:45 PM"
    TIME_FORMATS[HHMM_A], // "0345PM"
    TIME_FORMATS[HHA], // "3 PM"
    TIME_FORMATS[HH_MM_SS_A], // "03:45:35 PM"
    TIME_FORMATS[HH_MM_SS_SSS_A], // "03:45:35 PM"
  ],
  [LOCALES.EN_GB]: [
    TIME_FORMATS[HH_MM], // "15:45"
    TIME_FORMATS[HHMM], // "1545"
    TIME_FORMATS[HH_MM_SS], // "15:45:35"
    TIME_FORMATS[HH_MM_SS_SSS], // "15:45:35.300"
  ],
};
export const FALLBACK_TIME_FORMAT_KEYS_BY_LOCALE: Partial<Record<LocaleType, TimeFormatType[]>> = {
  [LOCALES.EN_GB]: SUPPORTED_TIME_FORMATS_BY_LOCALE[LOCALES.EN_US], // fallback to en-US formats
};

export const START_OF_DAY_TIME_PARTS = {
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
};
